import React from 'react';
import { Row } from 'shared/containers/portal_layout';
import { Link } from 'react-router';

const PatientMemberHeader = ({ patientMember }) => (
  <Row>
    <div className="span12">
      <div id="info-header" className="well">
        <div className="row-fluid">
          <h1>{patientMember.name}</h1>
          <Link
            to={`/a/portal/referral_profiles/new?existing_patient_id=${patientMember.patientId}`}
            className="btn btn-primary btn-mini"
          >
            Start New Referral
          </Link>
          <div className="row-fluid">
            <div className="span4">
              <h2>
                <span className="header-label">DOB:</span> {patientMember.dob} -{' '}
                {patientMember.ageWithMonths}
              </h2>
              <h2>
                <span className="header-label">Active:</span> {patientMember.activeStatusString}
              </h2>
              <h2>
                <span className="header-label">Location:</span> {patientMember.locationName}
              </h2>
            </div>
            <div className="span4">
              <h2>
                <span className="header-label">MRN:</span> {patientMember.medicalRecordNumber}
              </h2>
              <h3>
                <span className="header-label">SSN:</span> {patientMember.sanitizedSsn}
              </h3>
            </div>
            <div className="span4">
              {patientMember.formattedPrimaryPhone && (
                <h2>
                  <span className="header-label">Primary:</span>{' '}
                  {patientMember.formattedPrimaryPhone}
                </h2>
              )}
              {patientMember.formattedSecondaryPhone && (
                <h2>
                  <span className="header-label">Secondary:</span>{' '}
                  {patientMember.formattedSecondaryPhone}
                </h2>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Row>
);

export default PatientMemberHeader;
